import Swiper from '../util/swiper/swiper'
import noUiSlider from 'nouislider'
import $ from "jquery";
import mask from '../util/_masked_input'
import 'gasparesganga-jquery-loading-overlay'

export default {
    init() {
        // JavaScript to be fired on all pages
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        // Local variables
        let resizeTimer;
        const $window = $(window),
            body = $('body');

        /* phone mask */
        // $('.maskedPhone').mask('+7 (999) 999-99-99');

        /* input value change */
        let forminput = $('.input-item-input input');
        forminput.on('keyup change', function () {
            this.setAttribute('value', this.value);
        });

        /* mobile menu toggle switch */
        const mobMenuToggle = $('#mobMenuToggle'),
            mobMenuToggleIcon = $('#nav-icon3'),
            mobileNavMenu = $('#mobileNavMenu'),
            mobIcons = $('#header-contact-btns'),
            logoLink = $('#logolink'),
            mainNavCont = $('#main-nav-cont');

        function mobileMenuClose() {
            mainNavCont.removeClass('mob-nav-open');
            mobMenuToggle.removeClass('openedMenu');
            mobMenuToggleIcon.removeClass('open');
            mobileNavMenu.removeClass('landed');
            logoLink.addClass('onscreen');
            mobIcons.removeClass('onscreen');
            body.removeClass('scrollOff');
        }

        function mobileMenuOpen() {
            mainNavCont.addClass('mob-nav-open');
            mobMenuToggle.addClass('openedMenu');
            mobMenuToggleIcon.addClass('open');
            mobileNavMenu.addClass('landed');
            logoLink.removeClass('onscreen');
            mobIcons.addClass('onscreen');
            body.addClass('scrollOff');
        }

        mobMenuToggle.on('click', function () {
            langSelectClose();
            if ($(this).hasClass('openedMenu')) {
                mobileMenuClose();
            } else {
                $(this).addClass('openedMenu');
                mobileMenuOpen();
            }
            return false;
        });

        /* lang select toggle switch */
        const langSelect = $('#langSelect'),
            otherLangs = $('#other-langs-holder');

        function langSelectClose() {
            langSelect.removeClass('lsOpened');
            otherLangs.removeClass('olh-show');
        }

        function langSelectOpen() {
            langSelect.addClass('lsOpened');
            otherLangs.addClass('olh-show');
        }

        langSelect.on('click', function () {
            if ($(this).hasClass('lsOpened')) {
                langSelectClose();
            } else {
                langSelectOpen();
            }
            return false;
        });

        let swiper = new Swiper('.cards-slider', {
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 30,
            pagination: {
                el: '.cards-swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '#cards-next',
                prevEl: '#cards-prev'
            },
            breakpoints: {
                479: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    spaceBetween: 0
                },
                767: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 20
                },
                1023: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 30,
                }
            },
			on: {
				init: function () {
				  console.log('slides:' + $('.swiper-container .swiper-slide').length);
				},
			},
        });

        function expandOpening() {
            expandSwitch.addClass('switch-opened');
            expandZone.slideDown();
        }

        function expandClosing() {
            expandSwitch.removeClass('switch-opened');
            expandZone.slideUp();
        }

        let expandSwitch = $('.dac-switch'),
            expandZone = (expandSwitch.closest('section').find('.expandZone'));
        expandSwitch.on('click', function () {
            if ($(this).hasClass('switch-opened')) {
                expandClosing();
            } else {
                expandOpening();
            }
        });

        /* аккордеон на какой-то странице: */
        let accHead = $('.accordion-heading');
        accHead.on('click', function () {
            if ($(this).hasClass('acc-item-opened')) {
                $(this).removeClass('acc-item-opened');
                $(this).siblings('.accordion-content').slideUp();
            } else {
                $('.accordion-content').slideUp();
                accHead.removeClass('acc-item-opened');
                $(this).addClass('acc-item-opened');
                $(this).siblings('.accordion-content').slideDown();
            }
        });

        /* аккордеон на странице О нас */
        let accToggle = $('.acc-toggle');
        accToggle.on('click', function () {
            $(this).closest('.acc-item').toggleClass('acc-about-item-opened');
            $(this).closest('.acc-item').find('.acc-details').slideToggle();
        });

        /* select2 */
        $('.select2').select2({
            minimumResultsForSearch: -1
        });

        function resizeElements() {
            // Some recalculations on resize
        }

        $window.on('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(resizeElements, 100);
        });
        // Bind orientation change
        $window.on('orientationchange', function () {
            resizeElements();
        });
        // Fire once at startup
        resizeElements();

      // phone number ignore letters
      $("#phone_number").on("keydown", function(event) {

        //allows only these keys
        // backspace, delete, tab, escape, and enter
        if ( event.keyCode == 107 || event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 27 || event.keyCode == 13 ||
          // Ctrl+A
          (event.keyCode == 65 && event.ctrlKey === true) ||
          // home, end, left, right
          (event.keyCode >= 35 && event.keyCode <= 39)) {
          return;
        }
        else {
          // Ensure that it is a number and stop the keypress
          if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105 )) {
            event.preventDefault();
          }
        }

      });


        // ******* add custom form submit handler *******

        var recaptchaSiteKey = '6LdXklInAAAAALInN9c9rNIySqoO2sOamlEvm8te';
        $('.contact-form').submit(function (event) {
          event.preventDefault();

          var currentForm = $(this);
          var canSubmit = true;

          // remove all error classes
          $(".input-item").removeClass('input-error');
          $(".checkbox-item").removeClass('input-error');

          // check required fields
          $('input,textarea,select').filter('[required]:visible').each(function (index) {
            if($(this).val().trim() === "") {
              $(this).closest(".input-item").addClass('input-error');
              console.log('required input ' + $(this).id + " is empty");
              canSubmit = false;
            }
          });

          // check agree checkbox checked
          if($("#agree").length) {
            if (!$("#agree").prop('checked')) {
              console.log('accept terms is not checked');
              $("#agree").closest('.checkbox-item').addClass('input-error');
              canSubmit = false;
            }
          }

          // phone number validation
          var phoneInput = $("#phone_number");
          if(phoneInput.length) {
            var phone = phoneInput.first().val();
            if(phone.length < 10) {
              canSubmit = false;
              phoneInput.first().closest(".input-item").addClass('input-error');
            }
          }

          // check email has a right format
          if($("input[type='email']").length) {
            var mailInput = $("input[type='email']").first();
            var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            if(!regex.test(mailInput.val())) {
              canSubmit = false;
              mailInput.closest(".input-item").addClass('input-error');
            }
          }

          // if(canSubmit) {
          //   $.LoadingOverlay('show', {imageColor: '#39b54a'});
          //   $.ajax({
          //     type: "POST",
          //     url: '/wp-json/apibank/form',
          //     data: currentForm.serialize(), // serializes the form's elements.
          //     success: function(data)
          //     {
          //       $.LoadingOverlay('hide');
          //       console.log("form submitted; answer: " + data);
          //       currentForm.hide();
          //       $('#form-sended-block').removeClass('hidden');
          //     },
          //     error: function () {
          //       $.LoadingOverlay('hide');
          //       console.log("form submitted; error");
          //     }
          //   });
          // }

          if (canSubmit) {
              $.LoadingOverlay('show', { imageColor: '#39b54a' });

              grecaptcha.execute(recaptchaSiteKey, { action: 'submit' }).then(function (token) {
                  currentForm.append('<input type="hidden" name="g-recaptcha-response" value="' + token + '">');

                  $.ajax({
                      type: "POST",
                      url: '/wp-json/apibank/form',
                      data: currentForm.serialize(),
                      success: function (data) {
                          $.LoadingOverlay('hide');
                          console.log("form submitted; answer: " + data);
                          currentForm.hide();
                          $('#form-sended-block').removeClass('hidden');
                      },
                      error: function () {
                          $.LoadingOverlay('hide');
                          console.log("form submitted; error");
                      }
                  });
              }).catch(function (error) {
                  $.LoadingOverlay('hide');
                  console.log("reCAPTCHA: " + error);
              });
          }

          return false;
        });

        function resetForm(button){
          button.closest('form').find(".field-form").each(function (index, element) {
            if($(element).is('input')){
              if($(element).attr('type') === 'checkbox')
                $(element).prop('checked', true);
              else $(element).val('');
            }
            else if($(element).is('select'))
              $(element).val($($(element).find('option')[0]).val()).trigger('change.select2');
          });
        }

        $('#btnResetForm').on('click', function () {
          resetForm($(this));
        });

		// cookie consent
      var cookieText = $('header').attr('data-for-cookie-text'),
      cookieLinkText = $('header').attr('data-for-cookie-link-text'),
      cookieLinkHref = $('header').attr('data-for-cookie-link-href'),
      cookieButtonText = $('header').attr('data-for-cookie-button-text'),
      re = /\{link\}/gi;
      var newText = cookieText.replace(re, "<a href='" + cookieLinkHref + "'>" + cookieLinkText + "</a>");

		window.cookieconsent.initialise({
			palette:{
				popup: {background: "#383b75"},
				button: {background: "#39b54a",  text: '#fff'},
			},
			content: {
				dismiss: cookieButtonText,
				message: newText,
				link: ''
			},
			elements: {
				dismiss: '<button aria-label="dismiss cookie message" tabindex="0" class="cc-btn btn cc-dismiss">{{dismiss}}</button>',
			},
			onStatusChange: function(status) {
				console.log(this.hasConsented() ? 'enable cookies' : 'disable cookies');
			}
		});
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js